import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../App.css";
import { useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// import required modules
import { EffectCoverflow, Pagination } from "swiper";

function Projects() {
  const [choosenProjects, setChoosenProjects] = useState("html");

  return (
    <div
      className="bg-blue w-full h-full lg:px-16 px-7 overflow-x-hidden font-poor-story text-white lg:text-2xl md:text-lg text-base leading-loose tracking-widest relative"
      data-aos="fade-right"
      data-aos-easing="ease-in-sine"
      data-aos-duration="400">
      <Navbar
        pageTitle="Projects"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="500"
      />

      {/* TAPS */}
      <div
        className="mt-20 flex flex-wrap gap-4 justify-center items-center"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600">
        <h1
          className={`border-solid border-[1px] rounded px-3 py-1 cursor-pointer ${
            choosenProjects === "html" ? "border-orange" : "border-white"
          }`}
          onClick={() => setChoosenProjects("html")}>
          HTML & CSS
        </h1>
        <h1
          className={`border-solid border-[1px] rounded px-3 py-1 cursor-pointer ${
            choosenProjects === "bootstrap" ? "border-orange" : "border-white"
          }`}
          onClick={() => setChoosenProjects("bootstrap")}>
          Bootstrap
        </h1>
        <h1
          className={`border-solid border-[1px] rounded px-3 py-1 cursor-pointer ${
            choosenProjects === "js" ? "border-orange" : "border-white"
          }`}
          onClick={() => setChoosenProjects("js")}>
          Pure JS
        </h1>
        <h1
          className={`border-solid border-[1px] rounded px-3 py-1 cursor-pointer ${
            choosenProjects === "vue" ? "border-orange" : "border-white"
          }`}
          onClick={() => setChoosenProjects("vue")}>
          Vue
        </h1>
        <h1
          className={`border-solid border-[1px] rounded px-3 py-1 cursor-pointer ${
            choosenProjects === "react" ? "border-orange" : "border-white"
          }`}
          onClick={() => setChoosenProjects("react")}>
          React
        </h1>
      </div>

      {/* SWIPER */}
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 150,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper sm:h-[500px] h-[380px]">
        {choosenProjects === "html" && (
          <>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Dashboard</p>
              <a
                href="https://dashbo0ard.netlify.app/"
                target="_blank"
                rel="noreferrer">
                <img
                  src={require("../assets/projects/dashboard.png")}
                  alt=""
                  className="rounded-xl shadow-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/dashboard"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://dashbo0ard.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Fylo - Dark Theme
              </p>
              <a
                href="https://fyloodark.netlify.app/"
                target="_blank"
                rel="noreferrer">
                <img
                  src={require("../assets/projects/fylo.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/Fylo-dark-theme"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://fyloodark.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Clipboard</p>
              <a
                href="https://clipboardpage.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/clipboard.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/clipboard"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://clipboardpage.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Kasper Template
              </p>
              <a
                href="https://kaspertemplatee.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/kasper.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/Kasper-template"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://kaspertemplatee.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Landing page (Non-Responsive)
              </p>
              <a
                href="https://manageland.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/manage.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/manage-landing-page"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://manageland.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Landing page (Non-Responsive)
              </p>
              <a
                href="https://looppstudios.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/loopstudios.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/HTML-CSS-SASS/tree/Loob-studios"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://looppstudios.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
          </>
        )}

        {choosenProjects === "bootstrap" && (
          <>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Blondi Theme</p>
              <a
                href="https://bonditheme.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/blondi.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>

              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Bootstrap-Practice/tree/main/Bondi%20theme"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://bonditheme.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Mizuxe Theme</p>
              <a
                href="https://mizuxetheme.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/mizuxe.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Bootstrap-Practice/tree/main/Mizuxe"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://mizuxetheme.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Glozzom Theme</p>
              <a
                href="https://gloozzoom.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/gloozom.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Bootstrap-Practice/tree/main/Glozzom"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://gloozzoom.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
          </>
        )}

        {choosenProjects === "js" && (
          <>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Calculator (With Theme Switcher)
              </p>
              <a
                href="https://calculator-frontend-mentor-seven.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/calc.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Calculator---Frontend-Mentor"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://calculator-frontend-mentor-seven.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Rock, Paper, Scissors Game
              </p>
              <a
                href="https://rock-paper-scissors-frontend-mentor-chi.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/rock, paper, scissors.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Rock-Paper-Scissors---Frontend-Mentor"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://rock-paper-scissors-frontend-mentor-chi.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Movie Seats Booking
              </p>
              <a
                href="https://movieboking.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/seats booking.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/JavaScript-Practice/tree/main/2-Seats%20Booking"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://movieboking.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Hangman Game</p>
              <a
                href="https://hanggmangame.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/hangman.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/JavaScript-Practice/tree/main/Hangman%20game"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://hanggmangame.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
          </>
        )}

        {choosenProjects === "vue" && (
          <>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Space Tourism SPA
              </p>
              <a
                href="https://space-tourism-murex-three.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/space tourism.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/space-tourism"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://space-tourism-murex-three.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>

            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Invoices Management App
              </p>
              <a
                href="https://invoice-app-lake.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/invoices.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/invoice-app"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://invoice-app-lake.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Weather App</p>
              <a
                href="https://weather-app-blond-eight-32.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/weather.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/weather-app"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://weather-app-blond-eight-32.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">FireBlogs</p>
              <a
                href="https://fire-blog-psi.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/fireblogs.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/FireBlog"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://fire-blog-psi.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Find A Coach</p>
              <a
                href="https://find-a-coach-phi.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/find coach.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Find-A-Coach"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://find-a-coach-phi.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Todoist (Composition APIs)
              </p>
              <a
                href="https://vue-crud-app-iota.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/vue todoist.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/VUE_CRUD-APP"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://vue-crud-app-iota.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                Todo (Options APIs)
              </p>
              <a
                href="https://todo-app-rose-seven.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/todo.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/Todo-app---Frontend-Mentor"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://todo-app-rose-seven.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
          </>
        )}

        {choosenProjects === "react" && (
          <>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">
                House Marketplace
              </p>
              <a
                href="https://house-marketplace-react-lovat.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/house marketplace.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/house-marketplace-react"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://house-marketplace-react-lovat.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Github Finder</p>
              <a
                href="https://github-finder-rho-lake.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/github finder.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/github-finder"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://github-finder-rho-lake.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
            <SwiperSlide>
              <p className="break-all w-full p-3 text-center">Feedback App</p>
              <a
                href="https://feedback-app-eight-ashy.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-2xl">
                <img
                  src={require("../assets/projects/feedback.png")}
                  alt=""
                  className="rounded-xl"
                />
              </a>
              <p className="text-center mt-7 grid  grid-cols-2 gap-7">
                <a
                  href="https://github.com/Fatma-M/feedback-app"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Github Repo
                </a>
                <a
                  href="https://feedback-app-eight-ashy.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-2xl">
                  - Live Demo
                </a>
              </p>
            </SwiperSlide>
          </>
        )}
      </Swiper>

      <Footer />
    </div>
  );
}

export default Projects;
